import React from 'react'
import { useDispatch } from 'react-redux'
import { ElementTypesText } from '../../Forms/FormCreation/Constants/ElementTypesText'
import { openDrawer } from '../../store/FormCreation/drawerSlice'
import { removeEditorElement } from '../../store/FormCreation/globalSlice'

const TextInput = ({ placeHolder }) => (
  <div className="px-4 py-2 flex flex-col gap-1">
    <div className="font-semibold">{placeHolder}</div>
    <input type="text" className="bg-white p-1 rounded-lg border border-slate-300" />
  </div>
)

const TextArea = ({ placeHolder }) => (
  <div className="px-4 py-2 flex flex-col gap-1">
    <div className="font-semibold">{placeHolder}</div>
    <textarea rows={3} className="bg-white p-1 rounded-lg border border-slate-300" />
  </div>
)

const NumberInput = ({ placeHolder }) => (
  <div className="px-4 py-2 flex flex-col gap-1">
    <div className="font-semibold">{placeHolder}</div>
    <input type="number" className="bg-white p-1 rounded-lg border border-slate-300" />
  </div>
)

const EmailInput = ({ placeHolder }) => (
  <div className="px-4 py-2 flex flex-col gap-1">
    <div className="font-semibold">{placeHolder}</div>
    <input type="email" className="bg-white p-1 rounded-lg border border-slate-300" />
  </div>
)

const DateInput = ({ placeHolder }) => (
  <div className="px-4 py-2 flex flex-col gap-1">
    <div className="font-semibold">{placeHolder}</div>
    <input type="date" className="bg-white p-1 rounded-lg border border-slate-300" />
  </div>
)

const DropDown = ({ placeHolder, options }) => (
  <div className="px-4 py-2 flex flex-col gap-1">
    <div className="font-semibold">{placeHolder}</div>
    <select className="bg-white p-2 rounded-lg border border-slate-300">
      {options.map((option, index) => (
        <option key={index} value={option.label}>
          {option.label}
        </option>
      ))}
    </select>
  </div>
)

const CheckBox = ({ placeHolder, options }) => (
  <div className="px-4 py-2 flex flex-col gap-2">
    <div className="font-semibold">{placeHolder}</div>
    <div className="flex flex-col gap-2">
      {options.map((option, index) => (
        <label key={index} className="flex items-center gap-2">
          <input type="checkbox" name="checkbox" value={option.label} className="w-5 h-5" />
          {option.label}
        </label>
      ))}
    </div>
  </div>
)

const Radio = ({ placeHolder, options }) => (
  <div className="px-4 py-2 flex flex-col gap-2">
    <div className="font-semibold">{placeHolder}</div>
    {options.map((option, index) => (
      <label key={index} className="flex items-center gap-2">
        <input type="radio" name="radio-group" value={option.label} className="w-5 h-5" />
        {option.label}
      </label>
    ))}
  </div>
)

const ElementTypes = {
  'text': TextInput,
  'text-area': TextArea,
  'number': NumberInput,
  'email': EmailInput,
  'date': DateInput,
  dropdown: DropDown,
  checkbox: CheckBox,
  radio: Radio,
}

const FormElement = ({ withToolkit, ...props }) => {
  const { type, id } = props

  const dispatch = useDispatch()

  const deleteClick = () => {
    dispatch(removeEditorElement({ id }))
  }

  const editClick = () => {
    dispatch(openDrawer({ id }))
  }

  return (
    <>
      {ElementTypes[type]({ ...props })}
      {withToolkit && (
        <div className="group absolute inset-0 bg-transparent opacity-0 hover:opacity-100 flex p-2 px-10">
          <div className="flex gap-4 p-1 items-center text-lg h-max ml-auto">
            <div className="h-max p-1 px-2 rounded text-xs font-bold text-white bg-slate-900">
              {ElementTypesText[type]}
            </div>
            <button onClick={editClick}>✎</button>
            <button onClick={deleteClick}>🗑️</button>
          </div>
        </div>
      )}
    </>
  )
}

export default FormElement
